import React, { useEffect } from "react";
import { Container, Typography, Box } from "@mui/material";
import AppAppBar from "../homePage/AppAppBar";
import Footer from "../homePage/Footer";
import "./TermsofService.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const TermsofService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);
  
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const textColor = theme.palette.mode === "dark" ? "white" : "black";

  return (
    <>
      <AppAppBar showSubMenu={false} />
      <Container
        className="container"
        sx={{
          mt: { xs: 8, md: 10 },
          px: { xs: 2, md: 0 },
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          marginTop="1%"
          sx={{ mb: { xs: 3, md: 0 } }}
        >
          <Typography
            variant="h3"
            className="custom-h4"
            gutterBottom
            sx={{ color: textColor }}
          >
            Terms of Service
          </Typography>
        </Box>
        <Box
          className="box"
          sx={{
            mt: 1,
            px: { xs: 2, md: 0 },
            height: "calc(100vh - 200px)",
            overflowY: "auto",
            paddingRight: "1rem",
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            General
          </Typography>

          <Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            By accessing or using the Service, You acknowledge that You have
            read, understand and agree to be legally bound by these Terms of
            Service ("Terms of Service" or "Agreement") and you represent that
            you have the legal capacity to be bound by these Terms of Use
            whether or not You have a registered account for the Service.
          </Typography>
          <Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            Notwithstanding anything in the Terms of Service to the contrary,
            your rights to use certain material available on or through this
            Site may be subject to separate written license agreements with
            Nexensus ("Other Agreements").
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            Any attempt by you to modify these Terms of Service is expressly
            rejected by Nexensus and shall have no force or effect regarding
            your use of the Site. Nexensus reserve the right, at any time, to
            add to, change, update, or modify these Terms of Service, simply by
            posting such change, update, or modification on the Site and without
            any other notice to You. Any such change, update, or modification
            will be effective immediately upon posting on the Site. It is Your
            responsibility to review these Terms of Service from time to time to
            ensure that You continue to agree with all of its terms.
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            Please read these Terms of Service carefully as they contain
            important information regarding Your legal rights, remedies and
            obligations. These Terms of Service establish the rights that
            Nexensus and others in the user community will have in and to any
            content that You contribute to the Nexensus Dataset.
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Use of the Site
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            Nexensus grants you a personal, revocable, non-exclusive,
            non-transferable, limited license to access and use the Site and the
            Content conditioned upon your compliance with these Terms of
            Service.
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            You may not license, sublicense, transfer, sell, resell, publish,
            reproduce, and/or otherwise redistribute the Site, including the
            Content or any component thereof in any manner (including, but not
            limited to, via or as part of any Internet site). You may not a) use
            the Content or any portion of the Site as part of any intranet or
            other internal network; b) create archival or derivative works based
            on the Content or any portion thereof or c) modify,
            reverse-engineer, disassemble, decompile or store the Content or any
            portion of the Site. You may not use the Site for any illegal
            purpose or in any manner inconsistent with these Terms of Service.
            Nexensus may discontinue or change the Site and the Content, or
            their availability to you, at any time, however Nexensus is not
            under any obligation to update the Content following publication on
            the Site. The terms of these Terms of Use will survive any such
            discontinuation.
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Non-Commercial Use of the Nexensus Data
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            If You display or distribute all or part of the Nexensus Dataset
            (hereafter also referred to as the "Content"), You are required to
            provide attribution that is plainly visible to all users of the
            Content. Our recommended attribution guidelines, for usage are
            described below. Ultimately, You have the responsibility to ensure
            You are in full compliance with the license terms whenever You use
            or reuse the Content.
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Accessing the Site
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            Nexensus may provide a number of different ways for You to access
            portions of the Service. These may include, but are not necessarily
            limited to, copying Content directly from the Site, receiving an
            export data file or other form of data dump directly from Nexensus
            or by using the Nexensus API. You agree to utilize the Platform, in
            accordance with these Terms of Service and as outlined in the
            further documentation provided by us on the Site. For purposes of
            these Terms of Service, receipt of Content from the Platform by any
            means constitutes use of the Site and Service.
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            Nexensus does not allow You to use crawlers, spiders or other
            scraping technology to electronically cull data from the Site and
            Service. Any collection of any Content using these methods is a
            violation of these Terms of Service.
          </Typography>

          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            Nexensus reserves the right in its sole discretion (for any reason
            or for no reason) and at any time without notice to You to change,
            suspend or discontinue the availability of the Services. Nexensus
            hereby reserves the right to change the prices of any of its
            services without any intimation to the uses in advance.
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            Nexensus reserves its full right to decline registration of any
            person / entity for all or any of its services / features. It also
            reserves its right to discontinue any services or features of any
            service to any person or entity, without assigning any reason or
            fact whatsoever.
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Elements of the Service
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            Any graphical layout and schema of the Site, and all other elements
            of the Site, software applications, Content and the Service not
            described above are owned by Nexensus or its licensors, and may not
            be reproduced without permission.
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            In addition, You agree not to:
          </Typography>

          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            1. use the Site or Service in any unlawful manner or in any other
            manner that could damage, disable, overburden or impair the Site or
            Service;
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            2. impersonate any person or entity, or falsely state or otherwise
            misrepresent Yourself, Your age or Your affiliation with any person
            or entity;
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            3. solicit personal information from anyone under 18 or solicit
            passwords or personally identifying information for commercial or
            unlawful purposes;
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            4. use or attempt to use another's account, service or system
            without authorization from Nexensus, or create a false identity on
            the Site or Service.
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Payments, Cancellations and Refunds
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            All information, reports, content and access rights purchased on
            Nexensus are non refundable and non-cancellable. Therefore, please
            look at the sample of reports and information provided before
            purchasing them. If you face any problem with any report or
            information purchased, please contact the Nexensus team at
            <div>
              <a href="mailto:support@nexensus.com?subject=Subject%20Here&body=Body%20text%20here">
                support@nexensus.com
              </a>
              . However, in the case of non-delivery of ordered items, we shall
              refund payments made for the non-delivered items.
            </div>
          </Typography>

          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            We as a merchant shall be under no liability whatsoever in respect
            of any loss or damage arising directly or indirectly out of the
            decline of authorization for any Transaction.
          </Typography>

          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Proprietary Rights
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            This Site and Service are protected by copyright, trademark, and
            other laws of both the India and foreign countries. Except as
            expressly permitted in these Terms of Service, You may not
            reproduce, modify or prepare derivative works based on, distribute,
            sell, transfer, publicly display, publicly perform, transmit, or
            otherwise use this Site or the Service, or any portion thereof.
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Relationship of the Parties
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            You and Nexensus are independent contractors, and nothing in this
            Agreement will create any partnership, joint venture, agency,
            franchise, sales relationship, or employment relationship between
            the parties. You will have no authority to make or accept any offers
            or representations on Nexensus's behalf.
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Termination
          </Typography>

          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            Nexensus may terminate Your account, delete Your Nexensus entry and
            any of Your Content and/or prohibit You from using or accessing the
            Site for any reason, or no reason, at any time in its sole
            discretion, with or without notice.
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Disclaimer
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            NEXENSUS HEREBY DISCLAIMS ALL WARRANTIES. NEXENSUS IS MAKING THE
            SITE AND SERVICE AVAILABLE "AS IS" WITHOUT WARRANTY OF ANY KIND. YOU
            ASSUME THE RISK OF ANY AND ALL DAMAGE OR LOSS FROM USE OF, OR
            INABILITY TO USE, THE SITE OR SERVICE. TO THE MAXIMUM EXTENT
            PERMITTED BY LAW, WE EXPRESSLY DISCLAIM ANY AND ALL WARRANTIES,
            EXPRESS OR IMPLIED, REGARDING THE SITE AND SERVICE, INCLUDING, BUT
            NOT LIMITED TO, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS
            FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. NEXENSUS DOES NOT
            WARRANT THAT THE SITE OR SERVICE WILL MEET YOUR REQUIREMENTS OR THAT
            THE OPERATION OF THE SITE WILL BE UNINTERRUPTED OR ERROR-FREE.
          </Typography>

          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Limitation of Liability
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            NEXENSUS'S LIABILITY TO YOU IS LIMITED. TO THE MAXIMUM EXTENT
            PERMITTED BY LAW, IN NO EVENT SHALL NEXENSUS OR ITS DIRECTORS,
            EMPLOYEES, AFFILIATES OR AGENTS BE LIABLE TO YOU FOR DAMAGES OF ANY
            KIND (INCLUDING, BUT NOT LIMITED TO, SPECIAL, INCIDENTAL, OR
            CONSEQUENTIAL DAMAGES, LOST PROFITS, OR LOST DATA, REGARDLESS OF THE
            FORESEEABILITY OF THOSE DAMAGES) ARISING OUT OF OR IN CONNECTION
            WITH YOUR USE OF THE SITE OR SERVICE OR ANY OTHER MATERIALS OR
            SERVICES PROVIDED TO YOU BY NEXENSUS. THIS LIMITATION SHALL APPLY
            REGARDLESS OF WHETHER THE DAMAGES ARISE OUT OF BREACH OF
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            CONTRACT, TORT, OR ANY OTHER LEGAL THEORY OR FORM OF ACTION.
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          ></Typography>

          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Indemnity
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            You agree to indemnify, defend, and hold harmless Nexensus, its
            affiliates, officers, directors, employees, consultants, agents, and
            representatives from any and all third party claims, losses,
            liability, damages, and/or costs (including reasonable attorney fees
            and costs) arising from Your access to or use of the Site or Service
            (including the Content), Your violation of these Terms of Service,
            or Your infringement, or infringement by any other user of Your
            account, of any intellectual property or other right of any third
            party or Nexensus. Nexensus will notify You promptly of any such
            claim, loss, liability, or demand, and will provide You with
            reasonable assistance, at Your expense, in defending any such claim,
            loss, liability, damage, or cost.
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Governing Law
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            These Terms of Service shall be construed in accordance with and
            governed by the laws of the India, without reference to their rules
            regarding conflicts of law. You hereby irrevocably consent to the
            exclusive jurisdiction of the courts in Delhi, India in all disputes
            arising out of or related to the use of the Site or Service.
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Severability; Waiver
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            If, for whatever reason, a court of competent jurisdiction finds any
            term or condition in this Agreement to be unenforceable, all other
            terms and conditions will remain unaffected and in full force and
            effect. No waiver of any breach of any provision of this Agreement
            shall constitute a waiver of any prior, concurrent, or subsequent
            breach of the same or any other provisions hereof, and no waiver
            shall be effective unless made in writing and signed by an
            authorized representative of the waiving party.
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Change of Control
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            In the event of a change of control of Nexensus or the sale of
            substantially all of Nexensus's assets, all rights of Nexensus
            hereunder shall be transferable, without notice to you.
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Entire Agreement
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            These Terms of Service constitute the entire agreement between You
            and Nexensus regarding the use of the Site and Service, superseding
            any prior agreements between You and Nexensus relating to Your use
            of the Site and Service. Contact us by Email :
            <a href="mailto:info@nexensus.com?subject=Subject%20Here&body=Body%20text%20here">
              info@nexensus.com
            </a>
          </Typography>
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Trademarks
          </Typography>
          <Typography
            Typography
            className="custom-h4"
            gutterBottom
            sx={{
              fontSize: "13px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
            }}
          >
            The Nexensus mark and other Nexensus logos are registered trademarks
            of Nexensus in India.
          </Typography>
        </Box>
      </Container>
      <AppAppBar
        showSubMenu={false}
        showPricing={true}
        showContactUs={true}
        showPrivacy={true}
      />
      <Footer />
    </>
  );
};

export default TermsofService;
